var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('vue-good-table',{attrs:{"mode":"remote","total-rows":_vm.totalRecords,"is-loading":_vm.isLoading,"pagination-options":{
            enabled: false,
            dropdownAllowAll: true,
          },"rows":_vm.rows,"columns":_vm.columns,"sort-options":{
            enabled: false,
          }},on:{"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('span',[_vm._v(" "+_vm._s(props.formattedRow[props.column.field])+" ")])]}}])})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }